<script setup lang="ts">
import { NavigationBreadcrumbs } from '@shared/ui/menus'

import { useKidDetailHeader } from '../model/kid-detail-header.hook'

defineOptions({
  name: 'KidDetailHeader',
})

const {
  config,
} = useKidDetailHeader()
</script>

<template>
  <NavigationBreadcrumbs
    :config="config"
  />
</template>
